export default __webpack_public_path__ + "static/media/dog4.9ad7931b.png";